export default function genererIntervenantContrat() {
  return {
    nomWithAdresseAndCompteComptable: null,
    tiers: null,
    repartition: null,
    modeReglement: null,
    modeReglementId: null,
    tiersId: null,
    surFacture: false,
    selected: true,
  };
}
